import { IValidation } from 'source/NFR.types';

const Validation: React.FC<IValidation> = ({ message, fields = [] }) => (
  <div className="validation">
    {message}
    <ul>
      {fields?.map(field => (
        <li key={field}>{field}</li>
      ))}
    </ul>
  </div>
);

Validation.displayName = 'Validation';

export default Validation;
